import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shield, Activity } from "lucide-react";

/**
 * "Admin portal | Operations" switch shown in the header of both admin areas.
 * Renders nothing for non-admins (the routes and the API are admin-only anyway).
 */
export default function PortalSwitch({ variant = "light", className = "inline-flex" }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;

  const dark = variant === "dark";
  const wrap = dark
    ? "bg-[hsl(var(--ops-surface))] border-[hsl(var(--ops-border))]"
    : "bg-muted border-border";
  const item = (active) =>
    `flex items-center gap-1.5 rounded-md px-2.5 sm:px-3 h-7 text-[11px] sm:text-xs font-semibold transition-colors duration-150 whitespace-nowrap ${
      active
        ? dark
          ? "bg-[hsl(var(--ops-brand))] text-white shadow-sm"
          : "bg-zinc-900 text-white shadow-sm dark:bg-white dark:text-zinc-900"
        : dark
          ? "text-[hsl(var(--ops-text-muted))] hover:text-[hsl(var(--ops-text))]"
          : "text-muted-foreground hover:text-foreground"
    }`;

  return (
    <div data-testid="portal-switch" role="tablist" aria-label="Switch between admin portal and operations dashboard"
      className={`${className} items-center gap-0.5 rounded-lg border p-0.5 ${wrap}`}>
      <NavLink to="/admin" data-testid="portal-switch-admin" role="tab" className={({ isActive }) => item(isActive)}>
        <Shield className="size-3.5" />
        <span className="hidden sm:inline">Admin portal</span>
        <span className="sm:hidden">Admin</span>
      </NavLink>
      <NavLink to="/ops" data-testid="portal-switch-ops" role="tab" className={({ isActive }) => item(isActive)}>
        <Activity className="size-3.5" />
        <span className="hidden sm:inline">Operations</span>
        <span className="sm:hidden">Ops</span>
      </NavLink>
    </div>
  );
}
